/** A training word the rider can tap for one sentence of explanation (works on phones, unlike a tooltip). */
import { useId, useState, type ReactNode } from "react";
import { ABBREVIATIONS, TERMS, type TermKey } from "@/lib/terms";

const ABBR = new RegExp(`\\b(${Object.keys(ABBREVIATIONS).join("|")})\\b`);

/** A coach's text with its abbreviations ("below 142 bpm (LT1)") explained on tap: the first time each appears. */
export function TermText({ text }: { text: string }) {
  const parts = text.split(ABBR);
  const seen = new Set<string>();
  return (
    <>
      {parts.map((part, i) => {
        const k = i % 2 === 1 ? ABBREVIATIONS[part] : undefined;
        if (!k || seen.has(part)) return part;
        seen.add(part);
        return (
          <Term key={i} k={k}>
            {part}
          </Term>
        );
      })}
    </>
  );
}

export function Term({ k, children }: { k: TermKey; children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const id = useId();
  return (
    <span className="term">
      <button
        type="button"
        className="term-btn"
        aria-expanded={open}
        aria-controls={id}
        onClick={(e) => {
          e.stopPropagation();
          setOpen((o) => !o);
        }}
      >
        {children}
      </button>
      {open && (
        <span id={id} className="term-def" role="note" data-testid={`term-${k}`}>
          {TERMS[k]}
        </span>
      )}
    </span>
  );
}
